import { createContext, useContext, type ReactNode } from "react";
import { useBuyFlags, type UseBuyFlagsState, type BuyFlags } from "./use-buy-flags";

const Ctx = createContext<UseBuyFlagsState | null>(null);

export function BuyFlagsProvider({ children }: { children: ReactNode }) {
  const value = useBuyFlags();
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useBuyFlagsContext(): UseBuyFlagsState {
  const v = useContext(Ctx);
  if (!v) throw new Error("useBuyFlagsContext must be used within BuyFlagsProvider");
  return v;
}

export type BuyGate = "loading" | "allowed" | "blocked";

// Single source of the 3-state decision, reused by offers + summary gates.
export function useBuyGate(product: keyof BuyFlags): BuyGate {
  const { flags, status } = useBuyFlagsContext();
  if (status === "loading") return "loading";
  if (status === "error" || !flags[product]) return "blocked"; // fail-closed
  return "allowed";
}
